var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1860_5169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76 0.5H31.24C36.0781 0.5 40 4.42187 40 9.26V31.74C40 36.5781 36.0781 40.5 31.24 40.5H8.76C3.92187 40.5 0 36.5781 0 31.74V9.26C0 4.42187 3.92187 0.5 8.76 0.5Z",
    fill: "url(#paint0_linear_1860_5169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8195 29.533L12.8233 29.5342L11.4556 31.903C10.9564 32.7677 9.85078 33.0639 8.98609 32.5647C8.12156 32.0655 7.82516 30.9599 8.32437 30.0952L9.33188 28.3502L9.42859 28.1827C9.60125 27.9345 10.0273 27.5061 10.8797 27.5867C10.8797 27.5867 12.8855 27.8044 13.0306 28.8469C13.0306 28.8469 13.0503 29.1899 12.8195 29.533ZM32.2169 23.483H27.9522C27.6617 23.4634 27.535 23.3597 27.485 23.2994L27.4819 23.2939L22.9167 15.3867L22.9108 15.3906L22.637 14.9981C22.1883 14.3119 21.4758 16.0669 21.4758 16.0669C20.625 18.0225 21.5966 20.2458 21.9352 20.9178L28.2761 31.9006C28.7752 32.7652 29.8808 33.0616 30.7456 32.5622C31.6102 32.063 31.9066 30.9574 31.4072 30.0927L29.8217 27.3464C29.7909 27.2799 29.7375 27.0992 30.0627 27.0984H32.2169C33.2153 27.0984 34.0247 26.2891 34.0247 25.2906C34.0247 24.2922 33.2153 23.483 32.2169 23.483ZM23.9334 25.9405C23.9334 25.9405 24.1611 27.0984 23.2803 27.0984H7.51484C6.51641 27.0984 5.70703 26.2891 5.70703 25.2906C5.70703 24.2922 6.51641 23.4828 7.51484 23.4828H11.568C12.2223 23.445 12.3773 23.0672 12.3773 23.0672L12.3811 23.0691L17.6717 13.9053L17.6702 13.905C17.7666 13.728 17.6863 13.5606 17.6723 13.5342L15.925 10.5078C15.4258 9.64329 15.722 8.53751 16.5867 8.03844C17.4514 7.53923 18.557 7.83532 19.0562 8.70001L19.8666 10.1036L20.6755 8.70251C21.1747 7.83798 22.2803 7.54157 23.145 8.04095C24.0097 8.54016 24.3059 9.64563 23.8067 10.5103L16.4445 23.2619C16.4123 23.3395 16.4025 23.4614 16.642 23.4828H21.0427L21.0436 23.5258C21.0436 23.5258 23.587 23.5653 23.9334 25.9405Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1860_5169",
    x1: 20,
    y1: 0.5,
    x2: 20,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A74E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_5169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/App-store.53ed9c651aaec24193d541c04cb55362.svg";
export { ForwardRef as ReactComponent };